import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../i18n";
import { LeaveStateEnum } from "../../modal/leave-state";
import { leaveTypeLabel } from "../../modal/leave-type";

function InfoModal({ contact, onClose }) {
  const { t } = useTranslation();
  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-auto">
        <motion.div
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -15 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="bg-white p-6 rounded-2xl max-w-xl w-full shadow-[0_8px_30px_rgba(0,0,0,0.08)] border border-gray-100 relative"
        >
          <button
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 transition"
            onClick={onClose}
            aria-label={t("infoModal.close")}
          >
            <span className="text-2xl font-bold">×</span>
          </button>

          <h2 className="text-2xl font-semibold text-gray-800 mb-4 border-b pb-2">
            {t("infoModal.title")}
          </h2>

          <div className="space-y-2 text-sm text-gray-700">
            <div>
              <span className="font-medium text-gray-900">{t("infoModal.type")}:</span>{" "}
              {leaveTypeLabel(t, contact.leavesType)}
            </div>
            <div>
              <span className="font-medium text-gray-900">{t("infoModal.startDate")}:</span>{" "}
              {formatDate(contact.startDate)}
            </div>
            <div>
              <span className="font-medium text-gray-900">{t("infoModal.endDate")}:</span>{" "}
              {formatDate(contact.finishDate)}
            </div>
            <div>
              <span className="font-medium text-gray-900">{t("infoModal.totalDays")}:</span>{" "}
              {contact.totalDate}
            </div>
            <div>
              <span className="font-medium text-gray-900">{t("infoModal.comment")}:</span>{" "}
              {contact.comment ? (
                <span className="text-gray-600">{contact.comment}</span>
              ) : (
                <em className="text-gray-400">{t("infoModal.noComment")}</em>
              )}
            </div>

            {contact.rejectReason && contact.state === LeaveStateEnum.REJECTED && (
              <div>
                <span className="font-medium text-gray-900">{t("infoModal.rejectReason")}:</span>{" "}
                <span className="text-gray-600">{contact.rejectReason}</span>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}

export default InfoModal;
